/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './App.scss';
import './Styles/bootstrap.min.css';
import './Styles/styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import Error from 'Screens/Error';
import { validateSession } from 'Screens/Login/actions/Actions';
import { selectLocation } from 'store/Router/selectors';
import { selectIsLoggedIn, selectIsValidatingSession } from 'store/Sesion/selectors';
import { setUrlReturn } from 'Screens/Contextualization/Faraday/actions/Actions';

import errorHandler from './Common/Handlers/ErrorHandler';
import FileUploadContext from './Common/Components/FileUploadContext';
import RedirectModal from './Common/Components/RedirectModal';
import { Content, Wrapper } from './styled';
import { selectShowProcessingQueue } from 'store/FileUploaderContext/selector';
import SpinnerComponent from 'Common/Components/SpinnerContainer';

import NavMenuContext from 'Screens/Contextualization/NavMenu';
import SideBarContext from 'Screens/Contextualization/Sidebar';
import TabsContext from 'Screens/Contextualization/Tabs';
import CommandValidator from 'Common/Components/CommandValidator';
import { ShortcutProvider } from 'Context/Shortcut';
import ShortcutsHelp from 'Common/Components/ShortcutsHelp';

const App = ({ logOut, children }) => {
  const location = useSelector(selectLocation);
  const isValidatingSession = useSelector(selectIsValidatingSession);
  const showImportModal = useSelector(selectShowProcessingQueue);
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const isPublicRoute = location.pathname === '/login' ||
    location.pathname === '/forgotpass' ||
    location.pathname.startsWith('/resetpass') ||
    location.pathname === '/verify-email' ||
    location.pathname === '/logout';
  const showAppChrome = loggedIn && !isPublicRoute;

  useEffect(() => {
    dispatch(validateSession());
    errorHandler(logOut);
    setMounted(true);
  }, [dispatch]);

  useEffect(() => {
    if (!isPublicRoute) dispatch(setUrlReturn(location.pathname));
  }, [dispatch, isPublicRoute, location.pathname]);

  if (!mounted) return null;
  if (isValidatingSession) return <SpinnerComponent height="100%" />;
  return (
    <ShortcutProvider>
      <Wrapper>
        { showAppChrome && <NavMenuContext /> }
        { showAppChrome && <SideBarContext /> }
        { showAppChrome && <TabsContext /> }
        <Content>
          { children }
        </Content>
        <RedirectModal />
        <Error />
        { (showImportModal && loggedIn) && <FileUploadContext /> }
        <CommandValidator />
        <ShortcutsHelp />
      </Wrapper>
    </ShortcutProvider>
  );
};

export default App;
